import { FinancialModelData } from './financialModel'

/** Ad spend for campaign Months 1–4 as modeled, plus how the ramp reads. */
export interface AdRamp {
  /** Campaign Months 1, 2, 3 and 4 (Month 4 is the steady rate). */
  months: [number, number, number, number]
  /** True when any of Months 1–3 differs from the steady rate. */
  hasRamp: boolean
  /** First campaign month from which spend stays at the steady rate. */
  steadyFrom: number
}

/**
 * Reads the first campaign months' ad spend from the financial model, which
 * carries any custom month-by-month spend set in the calculator. Search
 * months are skipped, so Month 1 is always the first standard-campaign month.
 */
export function getAdRamp(model: FinancialModelData): AdRamp {
  const start = model.leaderMonths + 1
  const spend = [0, 1, 2, 3].map(
    (offset) => model.projection[start + offset]?.adSpend ?? 0,
  ) as [number, number, number, number]
  const steady = spend[3]
  let steadyFrom = 4
  while (steadyFrom > 1 && spend[steadyFrom - 2] === steady) steadyFrom--
  return { months: spend, hasRamp: steadyFrom > 1, steadyFrom }
}
